export const AgeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1629_8337)">
        <path
          d="M1.33334 14.6667C1.33334 13.2522 1.89525 11.8956 2.89544 10.8955C3.89563 9.89526 5.25219 9.33335 6.66668 9.33335C8.08116 9.33335 9.43772 9.89526 10.4379 10.8955C11.4381 11.8956 12 13.2522 12 14.6667H1.33334ZM6.66668 8.66669C4.45668 8.66669 2.66668 6.87669 2.66668 4.66669C2.66668 2.45669 4.45668 0.666687 6.66668 0.666687C8.87668 0.666687 10.6667 2.45669 10.6667 4.66669C10.6667 6.87669 8.87668 8.66669 6.66668 8.66669ZM11.5753 10.1554C12.5951 10.4175 13.5062 10.9946 14.1789 11.8046C14.8516 12.6146 15.2516 13.6161 15.322 14.6667H13.3333C13.3333 12.9267 12.6667 11.3427 11.5753 10.1554ZM10.2267 8.63802C10.7853 8.13834 11.2321 7.52624 11.5377 6.84185C11.8433 6.15746 12.0009 5.41621 12 4.66669C12.0014 3.75566 11.7684 2.8596 11.3233 2.06469C12.0784 2.21641 12.7577 2.62494 13.2456 3.22082C13.7336 3.8167 14.0002 4.56317 14 5.33335C14.0002 5.80833 13.8988 6.27786 13.7028 6.71047C13.5067 7.14308 13.2204 7.52878 12.863 7.84172C12.5057 8.15465 12.0857 8.38759 11.631 8.52493C11.1763 8.66227 10.6975 8.70082 10.2267 8.63802Z"
          fill="#3643BA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1629_8337">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
